import React from 'react';
import styled from '@emotion/styled';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import { layout } from 'src/shared/styles/variables';

import { ProviderFragment } from '../documents/getMyProvidersQuery.generated';
import {
    ProviderSelection,
    ProviderSelectionCard,
    ProviderSelectionContactUsBanner,
} from './ProviderSelection/ProviderSelection';

export interface AssignedProviderSelectionProps {
    providers: ProviderFragment[];
    onProviderPress: (uuid: string) => void;
    headerText: string;
    subTitleText: string;
}

export const AssignedProviderSelection: React.FC<AssignedProviderSelectionProps> = ({
    providers,
    onProviderPress,
    headerText,
    subTitleText,
}) => {
    const { t } = useTranslation();
    const { explorePageConnectWithSupport } = useFlags();

    return (
        <Container>
            <ProviderSelection
                title={headerText}
                subtitle={subTitleText}
                providers={providers}
                renderProvider={provider => (
                    <ProviderSelectionCard provider={provider} onPress={onProviderPress} />
                )}
            />
            {explorePageConnectWithSupport && (
                <ProviderSelectionContactUsBanner
                    description={t('providers:provider_selection.contact_us.something_different')}
                    action={t('providers:provider_selection.contact_us.end_of_results.action_text')}
                    tags={['selection_flow_contact_us_modal']}
                />
            )}
        </Container>
    );
};

const Container = styled.div({
    width: '100%',
    maxWidth: layout.containerBiggerWidth,
    margin: '0 auto',
});
